import snakeCaseKeys from 'snakecase-keys';

class AppBridge {
  constructor(callbacks) {
    this.app_version = this.get_app_version();
    this.os = this.get_os(callbacks);
  }

  get_app_version() {
    // get app version
    let app_info = window.navigator.userAgent.match(/Autopass\/(\d+\.\d+\.\d+)/);
    if (app_info != null) {
      return app_info[1];
    } else {
      return null;
    }
  }

  get_os(callbacks) {
    let user_agent = window.navigator.userAgent.toLowerCase();
    if (this.app_version) {
      if (user_agent.match(/android/) != null) {
        this.os_type = 'android';
        return new AndroidBridgeImpl(callbacks, this.app_version);
      }
      this.os_type = 'ios';
      return new WebkitBridgeImpl(callbacks, this.app_version);
    } else {
      return new UnknownJsBridge();
    }
  }

  toggleAutoRefresh(enable) {
    this.os.toggleAutoRefresh(enable);
  }

  executeBoardAction(id, action) {
  	// android / iOS 這邊會 parse snakecase 所以不能用 js 的 camelcase
		const newAction = snakeCaseKeys(action)
    this.os.executeBoardAction(id, JSON.stringify(newAction));
  }

  executeDeepLink(deepLink) {
    this.os.executeDeepLink(deepLink);
  }

  openBrowser(url) {
    this.os.openBrowser(url);
  }
}


// android
class AndroidBridgeImpl {
  constructor(callbacks, app_version) {
    this.app_version = app_version;
  }

  toggleAutoRefresh = enable => {
    window.autopass.toggleAutoRefresh(enable);
  };

  executeBoardAction = (id, action) => {
    window.autopass.executeBoardAction(id, action);
  };

  executeDeepLink(deepLink) {
    window.autopass.executeDeepLink(deepLink, false);
  }

  openBrowser(url) {
    window.autopass.openBrowser(url);
  }
}

// ios
class WebkitBridgeImpl {
  constructor(callbacks, app_version) {
    this.app_version = app_version;
  }

  toggleAutoRefresh = enable => {
    window.webkit.messageHandlers.toggleAutoRefresh.postMessage({
      enable: enable,
    });
  };

  executeBoardAction = (id, action) => {
    window.webkit.messageHandlers.executeBoardAction.postMessage({
      id: id,
      action: action,
    });
  };

  executeDeepLink(deepLink) {
    window.webkit.messageHandlers.executeDeepLink.postMessage({
      deepLink: deepLink,
      closeWebView: false,
    });
  }

  openBrowser(url) {
    window.webkit.messageHandlers.openBrowser.postMessage({ url: url });
  }
}

class UnknownJsBridge {
    toggleAutoRefresh = enable => {};
  }

export { AppBridge };
